import { render, staticRenderFns } from "./VerifyAccount.vue?vue&type=template&id=0b757213"
import script from "./VerifyAccount.vue?vue&type=script&lang=js"
export * from "./VerifyAccount.vue?vue&type=script&lang=js"
import style0 from "./VerifyAccount.vue?vue&type=style&index=0&id=0b757213&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports